import useLocale from '@/utils/useLocale'
import { Button, Form, Message, Space } from '@arco-design/web-react'
import { IconWechat } from '@arco-design/web-react/icon'
import IconGoogle from '@/assets/google.svg'
import { useEffect, useState } from 'react'
import { Spin } from '@arco-design/web-react'
import WeChatLogin from '../login/wechat-login'
import styles from './style/index.module.less'
import { useRouter } from 'next/router'
import { BindAuthRes } from '@/types/api'
import { setToken } from '@/utils/checkLogin'
import useGoogleAuth from '@/hooks/useGoogleAuth'
import LoginBtn from '@/pages/login/login-btn'
import CustomInput from '@/components/CustomInput'
import Link from 'next/link'
import { addEnhancedConversion, baiduRegisterEvent, emailFormValidator } from '@/utils'
import { registerApi } from '@/api/login'
import useAfterInformation from '@/hooks/useAfterOnboarding'
import { INVITE_CODE_STORAGE } from '@/utils/constants'
import MobileLangSwitch from '@/mobile-components/MobileLangSwitch'
import { getBdVid, getPromotionInfo } from '@/hooks/useBdVid'
import { gtagRegisterEvent } from '@/utils/gtagEvent'
import { qhTrackRegister } from '@/utils/track'
import PhoneLogin from '@/mobile-pages/login/phone-login'
import useLang from '@/utils/useLang'
import { useEmailCaptcha } from '@/hooks/useEmailCaptcha'

const initialValues = { email: '', password: '', invite_code: '' }

const Register = () => {
  const router = useRouter()
  const { query } = router
  const [form] = Form.useForm()
  const {
    email = '',
    sessionFlag: initSessionFlag = '',
    f = ''
  } = (query as {
    email: string
    sessionFlag: string
    f: string
  }) || {}
  const { qhclickid } = getBdVid()
  const promotionInfo = getPromotionInfo()

  const [inviteCode, setInviteCode] = useState('')
  const [sessionFlag, setSessionFlag] = useState(initSessionFlag as string)
  const [showWechat, setShowWechat] = useState(false)
  const [loading, setLoading] = useState(false)

  const t = useLocale()
  const { afterRegisterSuccess } = useAfterInformation({ rememberPassword: false })

  const [componentType, setComponentType] = useState<'email' | 'phone'>('phone')
  const lang = useLang()
  const handleSignUpRes = (params, signUpRes) => {
    signUpRes
      .then((res) => {
        const { code } = res?.data || {}

        if (code === 0) {
          Message.success(t['register.form.result.successMsg'])
          // 增加百度统计，注册转化成功
          baiduRegisterEvent()
          // qhTrackRegister({
          //   qhclickid,
          //   id: res?.data?.data?.user?.user_id
          // })
          gtagRegisterEvent()
          afterRegisterSuccess(params, res?.data)
        } else {
          console.log(code)
        }
      })
      .catch((err) => {
        console.log('err', err?.response)
        // 设置错误信息
        const { messages, email, password, invite_code } = err?.response?.data?.errors || {}
        if (messages) {
          Message.error(messages)
        }

        if (invite_code) {
          Message.error(invite_code?.[0])
        }

        form?.setFields({
          // 存在则展示，不存在不展示
          name: messages
            ? {
                value: params.name,
                error: {
                  message: messages
                }
              }
            : undefined,
          email: email?.[0]
            ? {
                value: params.email,
                error: {
                  message: email?.[0]
                }
              }
            : undefined,
          password: password?.[0]
            ? {
                value: params.password,
                error: {
                  message: password?.[0]
                }
              }
            : undefined,
          invite_code: invite_code?.[0]
            ? {
                value: params.invite_code,
                error: {
                  message: invite_code?.[0]
                }
              }
            : undefined
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleRegister = async (params) => {
    // 不再校验验证码
    // if (!isEffective) {
    //   Message.error(t['register.form.no.invite.code'])
    //   return
    // }

    setLoading(true)
    const signUpRes = registerApi({
      ...params,
      ...promotionInfo
    })
    handleSignUpRes(params, signUpRes)
  }

  function onSubmitClick() {
    form?.validate().then((values) => {
      addEnhancedConversion(values?.email)
      handleRegister(values)
    })
  }

  const { onCaptchaShow } = useEmailCaptcha(form, onSubmitClick)

  useEffect(() => {
    form?.setFieldValue(INVITE_CODE_STORAGE, inviteCode)
  }, [inviteCode])

  useEffect(() => {
    const curInviteCode = f || localStorage.getItem('invite_code') || ''
    setInviteCode(curInviteCode as string)
  }, [f])

  const onBindSuccess = (data: BindAuthRes) => {
    setToken(data?.access_token)
    if (!data?.user?.role) {
      window.location.href = window.location.origin + '/onboarding'
    } else {
      window.location.href = window.location.origin + '/board'
    }
  }

  const { googleAuth, isLoading } = useGoogleAuth({
    onBindSuccess,
    invite_code: inviteCode
  })

  useEffect(() => {
    if (lang === 'en-US') {
      setComponentType('email')
    }
  }, [lang])

  if (showWechat) {
    return (
      <WeChatLogin
        type="login"
        setShowWechat={setShowWechat}
        step=""
        sessionFlag={sessionFlag}
        setSessionFlag={setSessionFlag}
        inviteCode={inviteCode}
      />
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.lang}>
        <Link href="/board">{t['menu.platform.board']}</Link>
        <MobileLangSwitch />
      </div>
      <div className={styles.title}>{t['register.form.title']}</div>

      <Spin loading={isLoading}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <LoginBtn
            key="google"
            icon={<IconGoogle />}
            text={t['register.google']}
            onClick={() => {
              googleAuth()
            }}
          />

          <LoginBtn
            key="wechat"
            icon={<IconWechat style={{ color: '#00C800', width: '24px', height: '24px' }} />}
            text={t['register.wechat']}
            onClick={() => {
              setShowWechat(true)
            }}
          />
        </Space>

        <div className={styles['or-wrap']}>
          <div className={styles['or-line']}></div>
          <div className={styles['or']}>{t['register.or']}</div>
          <div className={styles['or-line']}></div>
        </div>
        {componentType === 'email' ? (
          <>
            <Form form={form} layout="vertical" initialValues={initialValues}>
              <Form.Item
                label={t['register.form.email.placeholder']}
                field="email"
                rules={[{ required: true, validator: emailFormValidator, message: t['login.form.email.errMsg'] }]}
                initialValue={email || ''}
              >
                <CustomInput
                  type="email"
                  placeholder={t['register.form.email.placeholder']}
                  disabled={!!email?.trim()}
                />
              </Form.Item>
              <Form.Item
                label={t['login.form.password.label']}
                field="password"
                rules={[{ required: true, message: t['login.form.password.errMsg'] }]}
              >
                <CustomInput type="password" placeholder={t['login.form.password.placeholder']} />
              </Form.Item>
              <Form.Item
                label={t['register.form.invite.label']}
                field="invite_code"
                rules={[{ required: false, message: t['login.form.invite.errMsg'] }]}
                // 邀请码逻辑仍然保留，但是不再展示，
                // 2024.05.22 继续展示邀请码
                // style={{ display: 'none' }}
              >
                <CustomInput type="text" placeholder={t['register.form.invite.placeholder']} />
              </Form.Item>
              <div
                className={styles.phone_register}
                onClick={() => {
                  setComponentType('phone')
                }}
              >
                {t['phone_register']}
              </div>
              <Button
                type="primary"
                id="captcha-button"
                long
                onClick={onCaptchaShow}
                loading={loading}
                className={styles['btn']}
              >
                {t['login.form.register']}
              </Button>
            </Form>
            <div className={styles['no-account']}>
              {t['login.have.account']}
              <span
                className={styles['no-account-text']}
                onClick={() => {
                  router.push('/login')
                }}
              >
                {t['login.form.title']}
              </span>
            </div>
          </>
        ) : (
          <PhoneLogin
            onChangeForm={(v) => {
              setComponentType(v)
            }}
          />
        )}
      </Spin>
    </div>
  )
}

export default Register
